import React, { ReactNode, useEffect } from 'react';
import { Card, Text, Loader, Stack, Image } from '@mantine/core';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { useOktaAuth } from '../../providers/okta-auth-provider';
import { UserRole } from '../../types/user';

interface RequiredAuthProps {
  children: ReactNode;
  requiredRoles?: UserRole[];
  requiredPermissions?: string[]; // Aggiungi supporto per i permessi
}

export function RequiredAuth({ children, requiredRoles = [], requiredPermissions = [] }: RequiredAuthProps) {
  const { isAuthenticated, isLoading, hasRole, userInfo } = useOktaAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  
  useEffect(() => {
    // Non fare nulla se stiamo ancora caricando
    if (isLoading) {
      return;
    }

    if (!isAuthenticated) {
      // Salva il percorso corrente per tornare dopo il login
      sessionStorage.setItem('originalUri', location.pathname);
      navigate({to: '/login'});
    } else if (requiredRoles.length > 0) {
      // Aspetta che userInfo sia caricato prima di controllare i ruoli
      if (userInfo && !hasRole(requiredRoles)) {
        // Utente non ha i ruoli necessari
        navigate({to: '/unauthorized'});
      }
    }
  }, [isAuthenticated, isLoading, navigate, location.pathname, requiredRoles, userInfo, hasRole]);
  
  
  if (isLoading) {
    return (
      <Stack align="center" justify="center" style={{ minHeight: '100vh' }}>
        <Card shadow="md" padding="xl" radius="md" style={{ width: '100%', maxWidth: 400 }}>
          <Stack align="center" m="lg">
            <Image
              src="/logo.png"
              height={60}
              fit="contain"
              alt="Logo"
            />
            <Text size="lg" fw={500} ta="center">
              Verifica autenticazione
            </Text>
            <Loader size="md" />
          </Stack>
        </Card>
      </Stack>
    );
  }
  
  if (!isAuthenticated) {
    return null;
  }
  
  if (requiredRoles.length > 0 && !hasRole(requiredRoles)) {
    return null;
  }
  
  return <>{children}</>;
}